"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Files = exports.FilesField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var FileDragDrop_1 = require("../../../FileDragDrop");
var fieldMaker_1 = require("../fieldMaker");
// TODO: Basta solamente questo?
// TODO: Possibile bug: al submit del form, il componente viene eliminato, ma al suo interno ci sono
// ancora dei setState in vita che mandano in crash l'applicazione. Come gestirli?
var FilesField = /** @class */ (function (_super) {
    __extends(FilesField, _super);
    function FilesField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (files) { return _this.props.onChange && _this.props.onChange(files, files); };
        return _this;
    }
    FilesField.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(FileDragDrop_1.FileDragDrop, { onChange: this.onChange, acceptedTypes: this.props.allowedTypes, fileSizeLimit: this.props.fileSizeLimit }));
    };
    return FilesField;
}(React.PureComponent));
exports.FilesField = FilesField;
exports.Files = (0, fieldMaker_1.makeField)(FilesField);
//# sourceMappingURL=Files.js.map